var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnLooksrare = function SvgIcnLooksrare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.351 3 1 8.355l9 8.996 9-8.996L13.649 3H6.35Zm-.486 3.405c2.274-2.283 5.996-2.283 8.27 0l1.946 1.946-1.946 1.946c-2.274 2.284-5.996 2.284-8.27 0L3.919 8.351l1.946-1.946Zm1.338 1.946a2.797 2.797 0 1 0 5.594 0 2.797 2.797 0 0 0-5.594 0ZM10 9.568a1.216 1.216 0 1 1 0-2.433 1.216 1.216 0 0 1 0 2.433Z",
    fill: "#595959"
  })));
};
export default SvgIcnLooksrare;